import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; 
import { ToastContainer, toast, cssTransition } from "react-toastify";
import "animate.css/animate.min.css";
import "react-toastify/dist/ReactToastify.css";
import auth from "../../../redux/actions/auth";
import "./style.css";

const Activate = () => {
  const [message, setMessage] = useState("Activation en cours...");
  const params = useParams();
  const navigate = useNavigate();

  const bounce = cssTransition({
    enter: "animate__animated animate__bounceIn",
    exit: "animate__animated animate__bounceOut",
  });

  useEffect(() => {
    const { uid, token } = params;
    console.log("🔍 uid reçu :", uid);
    console.log("🔍 token reçu :", token);

    const verify = async () => {
      try {
        console.log("🚀 Envoi de la requête d’activation...");
        const response = await auth.verify(uid, token);
        console.log("✅ Réponse backend :", response);
        setMessage("Votre compte a été activé avec succès !");
        toast.success("Votre compte a été activé !", { transition: bounce });
        setTimeout(() => navigate('/login'), 1000);
      } catch (err) {
        console.error("❌ Erreur lors de la vérification :", err);
        if (err.response) {
          console.error("🧾 Code d’erreur :", err.response.status);
          console.error("📩 Message d’erreur :", err.response.data);
        }
        setMessage("Erreur lors de l'activation du compte.");
        toast.error("Erreur d'activation !", { transition: bounce });
      }
    };

    verify();
  }, [params, navigate, bounce]);

  return (
    <div className="activate_header">
      <div className="activate_body">
        <h1>{message}</h1>
      </div>
      <ToastContainer transition={bounce} />
    </div>
  );
};

export default Activate;    